const API_KEY_MANAGEMENT_EXPERIENCE_TYPES = {
  CREATE: '[apiKeyManagementExperience] createApiKey',
  SET_CREATED: '[apiKeyManagementExperience] setCreated',
  EDIT: '[apiKeyManagementExperience] editApiKey',
  DELETE: '[apiKeyManagementExperience] deleteApiKey'
}

export default API_KEY_MANAGEMENT_EXPERIENCE_TYPES
